 
import Header from './components/Header';
import Hero from './components/Hero';
import Features from './components/Features';
import Services from './components/Services';
import Footer from './components/Footer';
 import Stats from './components/Stats';
 
export default function App() {
  return (
    <div className="bg-white text-gray-800">
      <Header />
      <Hero />
      <Services />
      <Features />
      <Stats /> 
      <Footer /> 
 
     </div>
  );
}